<template>
  <div class="delivery-address">
    <oie-base-dropdown-expand toggler-class="delivery-address__toggler" :use-caret="true">
      <template slot="toggler">
        <div
          v-if="selectedAddress"
          class="delivery-address__toggler-selected-state">
          {{ selectedAddress.name + ', ' + (selectedAddress.addressCo ? selectedAddress.addressCo + ', ' : '') + selectedAddress.addressLine1 + ', ' + selectedAddress.postalCode + ', ' + selectedAddress.city }}
        </div>
      </template>
      <template slot="content">
        <oie-action-wrapper>
          <template #left>
            <oie-base-input :value="filter" :placeholder="t('searchDeliveryAddressesPlaceholder')" @input="setFilter">
              <template #iconPrepend>
                <oie-base-icon icon="filter-icon" size="s"></oie-base-icon>
              </template>
            </oie-base-input>
          </template>
        </oie-action-wrapper>
        <div class="delivery-address-items">
          <ul class="delivery-address__items">
            <template v-for="(address, i) in filteredDeliveryAddresses">
              <li v-if="!address.useForShipping && (i < 3 || i >= 3 && !hideAddressRow)" :key="`checkout-addresses-${address.id}`" class="delivery-address__item">
                <oie-base-radio
                  :id="`address-${address.id}`"
                  classes-label="delivery-address__item-button"
                  name="shipmentAddress"
                  :value="`address-${address.id}`"
                  size="medium"
                  :label-text="address.name + ', ' + (address.addressCo ? address.addressCo + ', ' : '') + address.addressLine1 + ', ' + address.postalCode + ', ' + address.city"
                  :is-checked="selectedAddress.id === address.id"
                  @click.native="setAddress(address)">
                </oie-base-radio>
              </li>
            </template>
            <li v-if="(addresses.length) > 3" class="delivery-address__item">
              <button class="delivery-address__show-toggler" @click="toggleAddresses()">
                <template v-if="hideAddressRow">
                  {{ t('showAll') }}
                </template>

                <template v-else>
                  {{ t('showLess') }}
                </template>
              </button>
            </li>
          </ul>

          <div class="delivery-address__new-address-container">
            <oie-base-dropdown-expand
              :open-on-init="false"
              class="delivery-address__new-address-dropdown"
              toggler-class="delivery-address__new-address-toggler"
              toggle-subscribe-key="new.address.accordion.toggle">
              <template slot="toggler">
                {{ t('createAddressButtonLabel') }}
              </template>

              <template slot="content">
                <oie-checkout-address-new-inputs css-classes="delivery-address__new-address-input" :customer="customer"></oie-checkout-address-new-inputs>
              </template>
            </oie-base-dropdown-expand>
          </div>
        </div>
      </template>
    </oie-base-dropdown-expand>
  </div>
</template>

<script>
import accordion from '@/mixins/accordion.js'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  mixins: [accordion],
  props: {
    addresses: {
      type: Array,
      required: true
    },
    customer: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    hideAddressRow: true,
    initialAddressSet: false,
    filter: ''
  }),
  computed: {
    ...mapGetters('checkout', ['checkoutState']),
    selectedAddress() {
      var address = _.find(this.addresses, (o) => { return o.id === this.checkoutState.deliveryAddressId })
      if(address !== undefined) {
        return address
      } else {
        return _.find(this.addresses, (o) => { return o.isPreferredAddress })
      }
    },
    filteredDeliveryAddresses() {
      if (!this.filter) return this.addresses

      return _.filter(this.addresses, list => list.searchText.toLowerCase().includes(this.filter.toLowerCase()))
    }
  },
  watch: {
    addresses: {
      deep: true,
      handler(value) {
        if (!this.initialAddressSet && !this.checkoutState.deliveryAddress) {
          this.initialAddressSet = true
          var selectedAddress = _.find(value, { isPreferredAddress: true })
          if(selectedAddress) { this.setAddress(selectedAddress) }
        }
      }
    }
  },
  mounted () {
    this.subscribe('checkout-new-address', (value) => {
      var address = _.find(this.addresses, (o) => { return o.id === value.id })
      this.deliveryAddress = address
    })
  },
  methods: {
    toggleAddresses() {
      this.hideAddressRow = !this.hideAddressRow
    },
    setAddress(address) {
      this.publish('checkout-set-address', address)
    },
    setFilter(f) {
      this.filter = f
    }
  }
}
</script>

<style lang="scss">
.delivery-address {
  background-color: color(gray-5);
  box-shadow: 0 0 4px 0 rgba(170, 170, 170, 5);
}

.delivery-address__toggler {
  // border: 1px solid color(border-gray);
  background-color: color(background-gray-5);
}

.delivery-address__toggler-selected-state {
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  pointer-events: none;

  &:before {
    content: '';
    flex-shrink: 0;
    border: 2px solid color(green-2);
    border-radius: 50%;
    background-color: color(green-2);
    width: 1.25rem;
    height: 1.25rem;
    margin-right: measure(quarter);
  }

  &:after {
    content: '' ;
    position: absolute;
    top: 50%;
    left: .25rem;
    transform: translateY(-50%);
    background-image: url("data:image/svg+xml,%3Csvg width='30' height='28' viewBox='0 0 30 28' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.034 27.39L0 16.842l3.3-3.424 7.27 6.95L26.279.8 30 3.764z' fill='%23FFF' fill-rule='evenodd'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    width: .8rem;
    height: .7rem;
  }

  &:hover {
    cursor: pointer;
  }
}

.delivery-address-items {
  width: 100%;
  // margin-bottom: measure(double);
  background-color: color(background-white);
  border: 1px solid color(border-gray);

  @include media(medium) {
    width: 100%;
    max-width: 29.375rem;
  }
}

.delivery-address__items {
  list-style-type: none;
  margin: 0;
  padding: 0;
  border-bottom: 0;
}

.delivery-address__item {
  &:not(:last-child) {
    border-bottom: 1px solid color(border-gray);
  }
}

.delivery-address__show-toggler {
  @include reset-button;
  width: 100%;
  height: 3.125rem;
  padding: 0 measure(half) 0 measure(quarter);
}

.delivery-address__item-button {
  height: 3.125rem;
  margin: 0 measure(half) 0 measure(quarter);
}

.delivery-address__new-address-input {
  padding: measure(half);
}

// .delivery-address__new-address-dropdown {
//   border: 1px solid color(border-gray);
// }

.delivery-address__new-address-toggler {
  // background-color: color(background-white);
    border-top: 1px solid color(border-gray);
}

// .delivery-address__new-address-dropdown.dropdown-expand--is-open {
//   border: 1px solid color(border-blue-1);
// }

.delivery-address__new-address-dropdown > .dropdown-expand__content {
  padding: measure(half);
}

.delivery-address__label {
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;

  &:before {
    content: '';
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
    border: 2px solid gray;
    border-radius: 50%;
    margin-right: measure(quarter);
    transition: all 100ms linear;
  }

  &:after {
    content: '' ;
    position: absolute;
    top: 50%;
    left: .4rem;
    transform: translateY(-50%) translateX(-2rem);
    background-image: url("data:image/svg+xml,%3Csvg width='30' height='28' viewBox='0 0 30 28' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.034 27.39L0 16.842l3.3-3.424 7.27 6.95L26.279.8 30 3.764z' fill='%23FFF' fill-rule='evenodd'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    width: 1.1rem;
    height: 1.1rem;
    opacity: 0;
    transition: transform 120ms linear, opacity 120ms linear;
  }

  &:hover {
    cursor: pointer;
  }
}

  .delivery-address .action-wrapper {
    gap: 0;
  }

  .delivery-address .action-wrapper > .action-wrapper__container {
    width: 100%;
  }
</style>
